import { useEffect, useState } from "react";
import axios from "axios";

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
} from "@mui/material";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./AlarmReports.css";

const API_URL = process.env.REACT_APP_API_DJANGO_URL;

export default function AlarmReports() {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [alarms, setAlarms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alarmTypeFilter, setAlarmTypeFilter] = useState("ALL");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const token = localStorage.getItem("accessToken");
  const customerId = localStorage.getItem("customer_id");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");








  useEffect(() => {
    const fetchCustomers = async () => {
      // ✅ Customer Admin
      if (role === "CA" || role === "SE" || role === "DC") {
        setSelectedCustomer(customerId);

        // Optional: for PDF export
        setCustomers([
          {
            id: customerId,
            name: localStorage.getItem("customer_name") || "Customer",
          },
        ]);

        return;
      }

      try {
        const res = await axios.get(`${API_URL}/api/get_customers/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        const customerList = (res.data || []).map((c) => ({
          id: c.tb_customer_id,     // ✅ IMPORTANT FIX
          name: c.customer_name,
        }));

        setCustomers(customerList);

        // ✅ AUTO SELECT FIRST CUSTOMER
        if (customerList.length > 0) {
          setSelectedCustomer(customerList[0].id);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };

    fetchCustomers();
  }, [role, customerId]);
  // ================= FETCH SITES =================

  useEffect(() => {
    const fetchSites = async () => {
      if (!selectedCustomer) return;
      try {
        let siteItems = [];

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {},
        };

        // SUPERVISOR
        if (role === "S") {
          const res = await axios.get(
            `${API_URL}/api/supervisor_sites/${userId}/`,
            config,
          );

          siteItems = (res.data.sites || []).map((s) => ({
            id: s.asset_id,
            name: s.name,
          }));
        }

        // SITE ENGINEER
        else if (role === "SE") {
          const res = await axios.get(
            `${API_URL}/api/engineer_sites/${userId}/`,
            config,
          );

          siteItems = (res.data.sites || []).map((s) => ({
            id: s.asset_id,
            name: s.site_name,
          }));
        }

        // CUSTOMER
        else {
          const res = await axios.get(
            `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
            config,
          );

          siteItems = (res.data.data || []).map((s) => ({
            id: s.asset_id,
            name: s.name,
          }));
        }

        setSites(siteItems);

        if (siteItems.length > 0) {
          setSelectedSite(siteItems[0].id);
        }
      } catch (err) {
        console.error("Error fetching sites:", err);
      }
    };

    fetchSites();
  }, [selectedCustomer]);




  // ================= FETCH ALARMS =================

  useEffect(() => {
    const fetchAlarms = async () => {
      if (!selectedSite) return;

      setLoading(true);

      try {
        const res = await axios.get(
          `${API_URL}/api/get_alarms_menu/${selectedSite}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );

        setAlarms(res.data.data || []);
      } catch (err) {
        console.error("Alarm Fetch Error:", err);
        setAlarms([]);
      }

      setLoading(false);
    };

    fetchAlarms();
  }, [selectedSite]);

  // ================= STATUS LABEL =================

  const getStatusLabel = (status) => {
    const labels = {
      ACTIVE_UNACK: "Active / Unack",
      ACTIVE_ACK: "Active / Ack",
      CLEARED_UNACK: "Cleared / Unack",
      CLEARED_ACK: "Resolved",
    };

    return labels[status] || status;
  };

  // ================= FORMAT TIME =================

  const formatTime = (ts) => {
    if (!ts) return "-";
    return new Date(ts).toLocaleString();
  };

  // ================= CSV EXPORT =================

  const handleExportCSV = () => {

    const selectedSiteName =
      sites.find((s) => s.id === selectedSite)?.name || "Site";


    const selectedAlarmType =
      alarmTypeFilter === "ALL"
        ? "All Alarms"
        : alarmTypeFilter;

    const headers = [
      "Sr No",
      "Start Time",
      "Clear Time",
      "Originator",
      "Alarm Name",
      "Status",
      "Severity",
    ];

    // ✅ EXPORT FILTERED DATA ONLY
    const rows = filteredAlarms.map((a, i) => [
      i + 1,
      formatTime(a.startTs),
      a.clearTs ? formatTime(a.clearTs) : "Active",
      a.originatorName,
      a.type,
      getStatusLabel(a.status),
      a.severity,
    ]);

    const csvContent = [
      [`Site Name:,${selectedSiteName}`],

      // ✅ SHOW FILTER NAME
      [`Alarm Type:,${selectedAlarmType}`],

      [],

      headers,

      ...rows,
    ]
      .map((e) => e.join(","))
      .join("\n");

    const csv = "data:text/csv;charset=utf-8," + csvContent;

    const link = document.createElement("a");

    link.href = encodeURI(csv);

    link.download =
      `${selectedSiteName}_${selectedAlarmType}_alarm_report.csv`;

    link.click();
  };
  // ================= PDF EXPORT =================

  const handleExportPDF = () => {

    const selectedSiteName =
      sites.find((s) => s.id === selectedSite)?.name || "Site";


    //   const selectedCustomerName =
    // role === "CA" || role === "SE"
    //   ? localStorage.getItem("customer_name") || "Customer"
    //   : customers.find((c) => c.id === selectedCustomer)?.name || "Customer";
    const showCustomer =
      role !== "CA" && role !== "SE" && role !== "DC";

    const selectedCustomerName = showCustomer
      ? customers.find((c) => c.id === selectedCustomer)?.name || "Customer"
      : null;

    const selectedAlarmType =
      alarmTypeFilter === "ALL"
        ? "All Alarms"
        : alarmTypeFilter;

    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Alarm Report", 14, 15);

    doc.setFontSize(12);

    //    // ✅ CUSTOMER NAME (NEW)
    // doc.text(`Customer Name: ${selectedCustomerName}`, 14, 22);

    //   // ✅ SITE NAME
    //   doc.text(`Site Name: ${selectedSiteName}`, 14, 28);

    //   // ✅ ALARM TYPE
    //   doc.text(`Alarm Type: ${selectedAlarmType}`, 14, 33);

    let y = 22;

    if (selectedCustomerName) {
      doc.text(`Customer Name: ${selectedCustomerName}`, 14, y);
      y += 6;
    }

    doc.text(`Site Name: ${selectedSiteName}`, 14, y);
    y += 6;

    doc.text(`Alarm Type: ${selectedAlarmType}`, 14, y);

    autoTable(doc, {
      startY: 42,

      head: [
        [
          "Sr No",
          "Start Time",
          "Clear Time",
          "Originator",
          "Alarm Name",
          "Status",
          "Severity",
        ],
      ],

      // ✅ EXPORT FILTERED DATA ONLY
      body: filteredAlarms.map((a, i) => [
        i + 1,
        formatTime(a.startTs),
        a.clearTs ? formatTime(a.clearTs) : "Active",
        a.originatorName,
        a.type,
        getStatusLabel(a.status),
        a.severity,
      ]),
    });

    // doc.save(
    //   `${selectedCustomerName}_${selectedSiteName}_${selectedAlarmType}_alarm_report.pdf`
    // );

    const fileNameParts = [];

    if (role !== "CA" && role !== "SE" && role !== "DC") {
      const selectedCustomerName =
        customers.find((c) => c.id === selectedCustomer)?.name || "Customer";

      fileNameParts.push(selectedCustomerName);
    }

    fileNameParts.push(selectedSiteName);
    fileNameParts.push(selectedAlarmType);

    doc.save(`${fileNameParts.join("_")}_alarm_report.pdf`);
  };


  {/* ================= PAGINATION ================= */ }

  const filteredAlarms = alarms.filter((alarm) => {

    if (alarmTypeFilter === "ALL") {
      return true;
    }

    return (
      alarm.type?.trim().toLowerCase() ===
      alarmTypeFilter.trim().toLowerCase()
    );
  });

  const paginatedAlarms = filteredAlarms.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const totalFiltered = filteredAlarms.length;

  const startIdx =
    totalFiltered === 0 ? 0 : page * rowsPerPage + 1;

  const endIdx = Math.min(
    page * rowsPerPage + rowsPerPage,
    totalFiltered
  );


  return (
    <Box className="report-container">
      {/* TOP BAR */}

      <Box className="top-bar">
        {role !== "CA" && role !== "SE"  && role !== "DC" && (
          <FormControl className="dropdown">
            <InputLabel>Select Customer</InputLabel>

            <Select
              value={selectedCustomer}
              label="Select Customer"
              onChange={(e) => setSelectedCustomer(e.target.value)}
            >
              {customers.map((c) => (
                <MenuItem key={c.id} value={c.id}>
                  {c.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <FormControl className="dropdown">
          <InputLabel>Select Site</InputLabel>

          <Select
            value={selectedSite}
            label="Select Site"
            onChange={(e) => setSelectedSite(e.target.value)}
          >
            {sites.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        <FormControl className="dropdown">
          <InputLabel>Alarm Type</InputLabel>

          <Select
            value={alarmTypeFilter}
            label="Alarm Type"
            onChange={(e) => {
              setAlarmTypeFilter(e.target.value);
              setPage(0);
            }}
          >
            <MenuItem value="ALL">All</MenuItem>

            <MenuItem value="Low Water Level">
              Low Water Level
            </MenuItem>

            <MenuItem value="Low Diesel level">
              Low Diesel level
            </MenuItem>

            <MenuItem value="Lower Hydrant Pressure Alarm">
              Lower Hydrant Pressure Alarm
            </MenuItem>

            <MenuItem value="Lower Sprinkler Pressure Alarm">
              Lower Sprinkler Pressure Alarm
            </MenuItem>
          </Select>
        </FormControl>

        <Box className="export-buttons">
          <Button
            onClick={handleExportCSV}
            className="btn-csv"
            disabled={!alarms.length}
          >
            CSV
          </Button>

          <Button
            onClick={handleExportPDF}
            className="btn-pdf"
            disabled={!alarms.length}
          >
            PDF
          </Button>
        </Box>
      </Box>

      {/* TABLE */}

      <TableContainer component={Paper} className="table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Start Time</TableCell>
              <TableCell>Clear Time</TableCell>
              <TableCell>Originator</TableCell>
              <TableCell>Alarm Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Severity</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : alarms.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No Alarm Data
                </TableCell>
              </TableRow>
            ) : (
              paginatedAlarms.map((alarm, i) => (
                <TableRow key={i}>
                  <TableCell>{i + 1}</TableCell>

                  <TableCell>
                    {formatTime(alarm.startTs)}
                  </TableCell>

                  <TableCell>
                    {alarm.clearTs
                      ? formatTime(alarm.clearTs)
                      : "Active"}
                  </TableCell>

                  <TableCell>
                    {alarm.originatorName}
                  </TableCell>

                  <TableCell>
                    {alarm.type}
                  </TableCell>

                  <TableCell>
                    <span
                      className={`status-badge ${alarm.status.toLowerCase()}`}
                    >
                      {getStatusLabel(alarm.status)}
                    </span>
                  </TableCell>

                  <TableCell>
                    <span
                      className={`severity-badge severity-${alarm.severity.toLowerCase()}`}
                    >
                      {alarm.severity}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* PAGINATION */}

      <div className="pagination-bar">

        <div className="rows-select">
          Rows per page:

          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setPage(0);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
          </select>
        </div>

        <div className="page-info">
          {startIdx}-{endIdx} of {totalFiltered}
        </div>

        <div className="page-arrows">

          <button
            disabled={page === 0}
            onClick={() => setPage(page - 1)}
          >
            ‹
          </button>

          <button
            disabled={endIdx >= totalFiltered}
            onClick={() => setPage(page + 1)}
          >
            ›
          </button>

        </div>

      </div>
    </Box>
  );
}